(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calendly"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var path = window.location.pathname || '';
    if (path.indexOf('/pages/schedule') === -1) return;

    try {
      sessionStorage.setItem('tpa_schedule_visited', '1');
    } catch (e) {}

    var cartUpdate =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/update.js'
        : '/cart/update.js';

    fetch(cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { tpa_schedule_complete: 'yes' } })
    }).catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    function formatMoney(cents, moneyFormat) {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, moneyFormat);
      return (Number(cents) / 100).toFixed(2);
    }

    function cartRoot() {
      return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    }

    document.querySelectorAll('[data-cart-page]').forEach(function (page) {
      var form = page.querySelector('.cart-page__form');
      if (!form) return;
      var moneyFormat = page.getAttribute('data-money-format');
      var checkoutButton = page.querySelector('[data-cart-checkout]');
      var preCheckoutButton = page.querySelector('[data-cart-pre-checkout]');
      var dynamicCheckout = page.querySelector('[data-cart-dynamic-checkout]');
      var gateCheckout = page.getAttribute('data-gate-checkout') === 'true';
      var scheduleCompleteKey = page.getAttribute('data-schedule-complete-key') || 'tpa_schedule_complete';
      var meetingDateKey = page.getAttribute('data-meeting-date-key') || 'meeting_date';
      var meetingTimeKey = page.getAttribute('data-meeting-time-key') || 'meeting_time';
      var intakeNote = page.querySelector('[data-cart-intake-note]');
      var workflow = page.querySelector('[data-booking-workflow]');
      var bookingActions = page.querySelector('[data-cart-booking-actions]');
      var hasQuestionnaire = page.getAttribute('data-has-questionnaire') === 'true';
      var questionnaireErrorRequired = page.getAttribute('data-questionnaire-error-required') || '';
      var questionnaireErrorSave = page.getAttribute('data-questionnaire-error-save') || '';
      var bookingModalRoot = page.querySelector('[data-cart-booking-modal]');
      var questionnaireForm = page.querySelector('[data-cart-questionnaire-form]');
      var questionnaireOpenButton = page.querySelector('[data-cart-questionnaire-open]');
      var questionnaireNote = page.querySelector('[data-cart-questionnaire-note]');
      var questionnaireError = page.querySelector('[data-cart-questionnaire-error]');

      function setWorkflowStep(step) {
        if (!workflow) return;
        workflow.querySelectorAll('[data-workflow-step]').forEach(function (el) {
          var stepNumber = Number(el.getAttribute('data-workflow-step'));
          el.classList.remove('booking-workflow__step--active', 'booking-workflow__step--complete');
          if (stepNumber < step) el.classList.add('booking-workflow__step--complete');
          if (stepNumber === step) el.classList.add('booking-workflow__step--active');
        });
      }

      function isScheduleCompleteFromCart(cart) {
        if (!gateCheckout) return true;
        if (cart && cart.attributes) {
          if (cart.attributes[scheduleCompleteKey] === 'yes') return true;
          if (
            cart.attributes[meetingDateKey] &&
            String(cart.attributes[meetingDateKey]).trim() &&
            cart.attributes[meetingTimeKey] &&
            String(cart.attributes[meetingTimeKey]).trim()
          ) {
            return true;
          }
        }
        return false;
      }

      function setScheduleGateUi(complete) {
        if (!gateCheckout) return;

        // Schedule CTA always stays visible and can reopen the modal anytime.
        if (preCheckoutButton) {
          preCheckoutButton.hidden = false;
          preCheckoutButton.removeAttribute('hidden');
          preCheckoutButton.removeAttribute('aria-disabled');
          preCheckoutButton.setAttribute('aria-disabled', 'false');
        }
        if (checkoutButton) {
          checkoutButton.hidden = true;
        }
        if (dynamicCheckout) {
          dynamicCheckout.hidden = true;
        }
        if (bookingActions) {
          bookingActions.classList.toggle('is-schedule-complete', complete);
        }

        if (!complete) {
          setWorkflowStep(2);
          return;
        }

        if (hasQuestionnaire) {
          fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) {
              return response.json();
            })
            .then(function (cart) {
              setQuestionnaireUiComplete(isQuestionnaireCompleteFromCart(cart));
            })
            .catch(function () {
              setWorkflowStep(3);
            });
        } else {
          setWorkflowStep(3);
        }
      }

      function refreshScheduleGateFromCart() {
        if (!gateCheckout) return Promise.resolve();
        return fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            setScheduleGateUi(isScheduleCompleteFromCart(cart));
          })
          .catch(function () {
            var initial = page.getAttribute('data-schedule-initial-complete') === 'true';
            try {
              if (sessionStorage.getItem('tpa_schedule_visited') === '1') initial = true;
            } catch (e) {}
            setScheduleGateUi(initial);
          });
      }

      function openQuestionnaireModal() {
        if (!bookingModalRoot) return;
        bookingModalRoot.hidden = false;
        bookingModalRoot.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        var firstInput = questionnaireForm ? questionnaireForm.querySelector('[data-intake-input]') : null;
        if (firstInput) firstInput.focus();
      }

      function closeBookingModal() {
        if (!bookingModalRoot) return;
        bookingModalRoot.hidden = true;
        document.body.style.overflow = '';
      }

      function showQuestionnaireError(message) {
        if (!questionnaireError) return;
        if (message) {
          questionnaireError.textContent = message;
          questionnaireError.hidden = false;
        } else {
          questionnaireError.hidden = true;
          questionnaireError.textContent = '';
        }
      }

      function collectQuestionnaireAttributes() {
        var attributes = { tpa_questionnaire_complete: 'yes' };
        if (!questionnaireForm) return attributes;

        questionnaireForm.querySelectorAll('[data-intake-field]').forEach(function (fieldWrap) {
          var key = fieldWrap.getAttribute('data-field-key');
          var input = fieldWrap.querySelector('[data-intake-input]');
          if (!key || !input) return;
          attributes[key] = input.value.trim();
        });

        return attributes;
      }

      function validateQuestionnaire() {
        if (!questionnaireForm) return true;
        var valid = true;

        questionnaireForm.querySelectorAll('[data-intake-field][data-field-required="true"]').forEach(function (fieldWrap) {
          var input = fieldWrap.querySelector('[data-intake-input]');
          if (!input) return;
          if (!input.value.trim()) {
            valid = false;
            input.focus();
          }
        });

        if (!valid && questionnaireForm.reportValidity) {
          questionnaireForm.reportValidity();
        }

        return valid;
      }

      function saveQuestionnaireAttributes(attributes) {
        return fetch(cartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        });
      }

      function hydrateQuestionnaireFromCart(cart) {
        if (!questionnaireForm || !cart || !cart.attributes) return;

        questionnaireForm.querySelectorAll('[data-intake-field]').forEach(function (fieldWrap) {
          var key = fieldWrap.getAttribute('data-field-key');
          var input = fieldWrap.querySelector('[data-intake-input]');
          if (!key || !input || cart.attributes[key] == null) return;
          input.value = cart.attributes[key];
        });
      }

      function isQuestionnaireCompleteFromCart(cart) {
        if (!hasQuestionnaire) return true;
        if (!cart || !cart.attributes) return false;
        if (cart.attributes.tpa_questionnaire_complete === 'yes') return true;

        var complete = true;
        if (!questionnaireForm) return false;

        questionnaireForm.querySelectorAll('[data-intake-field][data-field-required="true"]').forEach(function (fieldWrap) {
          var key = fieldWrap.getAttribute('data-field-key');
          if (!key || !cart.attributes[key] || !String(cart.attributes[key]).trim()) {
            complete = false;
          }
        });

        return complete;
      }

      function setQuestionnaireUiComplete(complete) {
        if (bookingActions) {
          bookingActions.classList.toggle('is-questionnaire-complete', complete);
        }

        if (questionnaireOpenButton) {
          questionnaireOpenButton.hidden = !hasQuestionnaire;
          questionnaireOpenButton.disabled = complete;
          questionnaireOpenButton.setAttribute('aria-disabled', complete ? 'true' : 'false');
        }

        if (questionnaireNote) questionnaireNote.hidden = complete || !hasQuestionnaire;
        if (intakeNote) {
          intakeNote.hidden = !complete || !hasQuestionnaire;
          if (complete) intakeNote.removeAttribute('hidden');
        }

        if (gateCheckout && !isScheduleCompleteFromCart(null)) {
          setWorkflowStep(2);
          return;
        }

        if (complete) {
          setWorkflowStep(hasQuestionnaire ? 4 : 3);
        } else if (!gateCheckout) {
          setWorkflowStep(3);
        }
      }

      function handleQuestionnaireSubmit(event) {
        event.preventDefault();
        showQuestionnaireError('');

        if (!validateQuestionnaire()) {
          showQuestionnaireError(questionnaireErrorRequired);
          return;
        }

        var attributes = collectQuestionnaireAttributes();
        var submitButton = questionnaireForm ? questionnaireForm.querySelector('[type="submit"]') : null;
        if (submitButton) submitButton.disabled = true;

        saveQuestionnaireAttributes(attributes)
          .then(function () {
            try {
              sessionStorage.setItem('tpa_questionnaire_complete', '1');
            } catch (e) {}
            closeBookingModal();
            setQuestionnaireUiComplete(true);
          })
          .catch(function () {
            showQuestionnaireError(questionnaireErrorSave);
          })
          .finally(function () {
            if (submitButton) submitButton.disabled = false;
          });
      }

      if (gateCheckout) {
        document.addEventListener('meeting-schedule:saved', refreshScheduleGateFromCart);
        window.addEventListener('pageshow', refreshScheduleGateFromCart);

        if (preCheckoutButton && preCheckoutButton.getAttribute('data-modal-open')) {
          preCheckoutButton.addEventListener('click', function (event) {
            var id = (preCheckoutButton.getAttribute('data-modal-open') || '').trim();
            if (!id) return;
            var root = document.querySelector('[data-pa-modal][data-modal-id="' + id + '"]');
            if (!root) return;
            event.preventDefault();
            root.hidden = false;
            root.classList.add('is-open');
            document.body.classList.add('pa-modal-open');
            document.body.style.overflow = 'hidden';
            var closeBtn = root.querySelector('[data-pa-modal-close]');
            if (closeBtn) closeBtn.focus();
            root.querySelectorAll('[data-meeting-schedule]').forEach(function (schedule) {
              if (!schedule.__meetingSchedule) return;
              schedule.__meetingSchedule.unlockForm();
              schedule.__meetingSchedule.prefillFromCart();
            });
          });
        }
      }

      if (hasQuestionnaire) {
        if (questionnaireOpenButton) {
          questionnaireOpenButton.addEventListener('click', openQuestionnaireModal);
        }

        if (questionnaireForm) {
          questionnaireForm.addEventListener('submit', handleQuestionnaireSubmit);
        }

        page.querySelectorAll('[data-cart-booking-close]').forEach(function (button) {
          button.addEventListener('click', closeBookingModal);
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && bookingModalRoot && !bookingModalRoot.hidden) {
            closeBookingModal();
          }
        });

        fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            hydrateQuestionnaireFromCart(cart);
            setQuestionnaireUiComplete(isQuestionnaireCompleteFromCart(cart));
            if (gateCheckout) {
              setScheduleGateUi(isScheduleCompleteFromCart(cart));
            }
          })
          .catch(function () {
            setQuestionnaireUiComplete(false);
            if (gateCheckout) {
              refreshScheduleGateFromCart();
            }
          });
      } else if (gateCheckout) {
        refreshScheduleGateFromCart();
      }

      var cartAddonsSectionId = null;
      var cartAddonsSectionNode = null;
      var cartAddonsConfigEl = document.querySelector('[data-cart-addons-config]');

      if (cartAddonsConfigEl) {
        try {
          cartAddonsSectionId = JSON.parse(cartAddonsConfigEl.textContent).sectionId;
        } catch (e) {
          cartAddonsSectionId = null;
        }
      }

      if (cartAddonsSectionId) {
        cartAddonsSectionNode = document.getElementById('shopify-section-' + cartAddonsSectionId);
      }

      function syncAddonGroup() {
        var group = page.querySelector('.cart-page__group--addons');
        if (!group) return;
        var items = group.querySelectorAll('[data-cart-item]');
        group.hidden = items.length === 0;
      }

      function applyCartAddonsSection(html) {
        if (!cartAddonsSectionNode || typeof html !== 'string') return;
        cartAddonsSectionNode.innerHTML = html;
        cartAddonsSectionNode.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      }

      function refreshCartAddonsSection() {
        if (!cartAddonsSectionId || !cartAddonsSectionNode) return Promise.resolve();

        var sectionsUrl = window.location.pathname + window.location.search;
        var separator = sectionsUrl.indexOf('?') >= 0 ? '&' : '?';

        return fetch(
          sectionsUrl + separator + 'sections=' + encodeURIComponent(cartAddonsSectionId),
          { headers: { Accept: 'application/json' } }
        )
          .then(function (response) {
            if (!response.ok) throw new Error('Section refresh failed');
            return response.json();
          })
          .then(function (data) {
            applyCartAddonsSection(data[cartAddonsSectionId]);
          })
          .catch(function () {});
      }

      function updateTotals(cart) {
        var subtotal = page.querySelector('[data-cart-subtotal]');
        var discount = page.querySelector('[data-cart-discount]');
        var countLabel = page.querySelector('[data-cart-count-label]');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price, moneyFormat);
        if (discount && cart.total_discount > 0) {
          discount.textContent = '−' + formatMoney(cart.total_discount, moneyFormat);
        }
        if (countLabel) {
          countLabel.textContent =
            cart.item_count === 1 ? cart.item_count + ' item' : cart.item_count + ' items';
        }
        document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
          badge.hidden = cart.item_count < 1;
          badge.textContent = cart.item_count;
        });
      }

      function isServiceCartItem(item) {
        var type = String(item.product_type || '').toLowerCase();
        if (type === 'service') return true;
        var serviceHandles = window.__tpaServiceHandles || [];
        return serviceHandles.indexOf(item.handle) !== -1;
      }

      function isAddonCartItem(item) {
        if (isServiceCartItem(item)) return false;
        var type = String(item.product_type || '').toLowerCase();
        if (type === 'add-on' || type === 'addon') return true;
        var addonHandles = window.__tpaAddonHandles || [];
        return addonHandles.indexOf(item.handle) !== -1;
      }

      function cartHasServiceInItems(items) {
        return (items || []).some(isServiceCartItem);
      }

      function updateCartItems(updates) {
        var payload = { updates: updates };
        if (cartAddonsSectionId) {
          payload.sections = cartAddonsSectionId;
          payload.sections_url = window.location.pathname;
        }

        return fetch(cartRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        });
      }

      function fetchCartState() {
        return fetch(cartRoot() + 'cart.js', {
          headers: { Accept: 'application/json' }
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart fetch failed');
          return response.json();
        });
      }

      function buildRemovalUpdates(cart, removedKey) {
        var updates = {};
        updates[removedKey] = 0;

        var removedItem = (cart.items || []).find(function (item) {
          return item.key === removedKey;
        });
        var remainingServices = (cart.items || []).filter(function (item) {
          return item.key !== removedKey && isServiceCartItem(item);
        });

        if (removedItem && isServiceCartItem(removedItem) && remainingServices.length === 0) {
          (cart.items || []).forEach(function (item) {
            if (isAddonCartItem(item)) updates[item.key] = 0;
          });
        }

        return updates;
      }

      function syncCartItemsDom(cart) {
        form.querySelectorAll('[data-cart-item]').forEach(function (itemRow) {
          var itemKey = itemRow.getAttribute('data-key');
          var stillInCart = (cart.items || []).some(function (item) {
            return item.key === itemKey;
          });
          if (!stillInCart) itemRow.remove();
        });

        var serviceGroup = page.querySelector('.cart-page__group--services');
        if (serviceGroup && !serviceGroup.querySelector('[data-cart-item]')) {
          serviceGroup.hidden = true;
        }

        syncAddonGroup();
      }

      function applyCartSections(cart) {
        if (cart.sections && cartAddonsSectionId && cart.sections[cartAddonsSectionId]) {
          applyCartAddonsSection(cart.sections[cartAddonsSectionId]);
        } else {
          refreshCartAddonsSection();
        }
      }

      function handleCartResponse(cart, changedKey) {
        if (cart.item_count < 1) {
          window.location.reload();
          return;
        }

        if (!cartHasServiceInItems(cart.items)) {
          var addonUpdates = {};
          var hasAddons = false;
          (cart.items || []).forEach(function (item) {
            if (isAddonCartItem(item)) {
              addonUpdates[item.key] = 0;
              hasAddons = true;
            }
          });

          if (hasAddons) {
            updateCartItems(addonUpdates).then(function () {
              window.location.reload();
            }).catch(function () {
              window.location.reload();
            });
            return;
          }

          window.location.reload();
          return;
        }

        syncCartItemsDom(cart);

        var line = (cart.items || []).find(function (item) {
          return item.key === changedKey;
        });

        if (line) {
          var price = row.querySelector('[data-line-price]');
          var compare = row.querySelector('[data-line-compare]');
          if (price) price.textContent = formatMoney(line.final_line_price, moneyFormat);
          if (compare) {
            if (line.original_line_price > line.final_line_price) {
              compare.hidden = false;
              compare.textContent = formatMoney(line.original_line_price, moneyFormat);
            } else {
              compare.hidden = true;
            }
          }
        }

        updateTotals(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        applyCartSections(cart);
      }

      function changeItem(key, quantity) {
        var payload = { id: key, quantity: quantity };
        if (cartAddonsSectionId) {
          payload.sections = cartAddonsSectionId;
          payload.sections_url = window.location.pathname;
        }

        return fetch(cartRoot() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        });
      }

      form.querySelectorAll('[data-cart-item]').forEach(function (row) {
        var key = row.getAttribute('data-key');
        var input = row.querySelector('[data-qty-input]');

        function applyQuantity(next) {
          var quantity = Math.max(0, next);
          if (input) input.value = quantity;

          var request;
          if (quantity === 0) {
            request = fetchCartState()
              .then(function (cart) {
                return updateCartItems(buildRemovalUpdates(cart, key));
              });
          } else {
            request = changeItem(key, quantity);
          }

          request
            .then(function (cart) {
              handleCartResponse(cart, key);
            })
            .catch(function () {
              form.submit();
            });
        }

        row.querySelectorAll('[data-qty-change]').forEach(function (button) {
          button.addEventListener('click', function () {
            var current = Number(input && input.value ? input.value : 1);
            applyQuantity(current + Number(button.getAttribute('data-qty-change')));
          });
        });

        if (input) {
          input.addEventListener('change', function () {
            applyQuantity(Number(input.value || 0));
          });
        }

        var remove = row.querySelector('[data-cart-remove]');
        if (remove) {
          remove.addEventListener('click', function (event) {
            event.preventDefault();
            applyQuantity(0);
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function cleanId(value) {
      return String(value || '')
        .replace(/^#/, '')
        .trim()
        .toLowerCase();
    }

    function maskEmail(email) {
      var value = String(email || '').trim();
      var at = value.indexOf('@');
      if (at < 1) return '';
      var local = value.slice(0, at);
      var domain = value.slice(at + 1);
      if (!domain) return '';
      if (local.length > 4) {
        return local.slice(0, 2) + '****' + local.slice(-2) + '@' + domain;
      }
      if (local.length > 2) {
        return local.slice(0, 2) + '****@' + domain;
      }
      return '****@' + domain;
    }

    function urlOrderId() {
      try {
        var params = new URLSearchParams(window.location.search);
        return cleanId(params.get('order_id') || params.get('order') || '');
      } catch (e) {
        return '';
      }
    }

    function orderEmailMasked(root) {
      var fromAttr = root.getAttribute('data-masked-order-email') || '';
      if (fromAttr) return fromAttr;
      try {
        var params = new URLSearchParams(window.location.search);
        return maskEmail(params.get('email') || params.get('order_email') || '');
      } catch (e) {
        return '';
      }
    }

    function showInvalid(root) {
      root.setAttribute('data-order-access', 'mismatch');
      var main = root.querySelector('[data-custom-form-main]');
      var gate = root.querySelector('[data-custom-form-invalid]');
      if (main) main.hidden = true;
      if (gate) {
        gate.hidden = false;
        var textEl = gate.querySelector('[data-invalid-text-el]');
        if (textEl) {
          var masked = orderEmailMasked(root);
          if (masked) {
            var template = root.getAttribute('data-invalid-text') || '';
            textEl.textContent = template.replace(/EMAIL/g, masked);
          } else {
            textEl.textContent = root.getAttribute('data-invalid-text-no-email') || '';
          }
        }
      }
    }

    function enforceOrderOwnership(root) {
      if (!root) return false;
      if (root.getAttribute('data-customer-logged-in') !== 'true') return false;
      if (root.getAttribute('data-order-access') === 'mismatch') return true;

      var orderId = urlOrderId();
      if (!orderId) return false;

      if (root.getAttribute('data-order-matched') === 'true') return false;

      var ownedIds = (root.getAttribute('data-customer-order-ids') || '')
        .split(',')
        .map(cleanId)
        .filter(Boolean);

      if (ownedIds.indexOf(orderId) !== -1) return false;

      showInvalid(root);
      return true;
    }

    function cleanOrderId(value) {
      return String(value || '')
        .replace(/^#/, '')
        .trim()
        .toLowerCase();
    }

    function submissionKeys(root, orderId) {
      var prefix = root.getAttribute('data-submission-storage-key') || 'tpa_custom_form_submitted';
      var id = cleanOrderId(orderId);
      if (!id) return [];
      return [prefix + ':' + id, prefix + ':#' + id];
    }

    function readCookie(name) {
      var match = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
      );
      return match ? decodeURIComponent(match[1]) : null;
    }

    function hasLocalSubmission(root, orderId) {
      var keys = submissionKeys(root, orderId);
      if (!keys.length) return false;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        try {
          if (window.localStorage && localStorage.getItem(key) === '1') return true;
        } catch (e) {}
        try {
          if (window.sessionStorage && sessionStorage.getItem(key) === '1') return true;
        } catch (e) {}
        try {
          var cookieName = key.replace(/[^a-zA-Z0-9_]/g, '_');
          if (readCookie(cookieName) === '1') return true;
        } catch (e) {}
      }
      return false;
    }

    function markLocalSubmission(root, orderId) {
      var keys = submissionKeys(root, orderId);
      keys.forEach(function (key) {
        try {
          window.localStorage && localStorage.setItem(key, '1');
        } catch (e) {}
        try {
          window.sessionStorage && sessionStorage.setItem(key, '1');
        } catch (e) {}
        try {
          var cookieName = key.replace(/[^a-zA-Z0-9_]/g, '_');
          document.cookie = cookieName + '=1; path=/; max-age=31536000; SameSite=Lax';
        } catch (e) {}
      });
    }

    function showAlreadySubmitted(root) {
      root.setAttribute('data-order-access', 'submitted');
      var main = root.querySelector('[data-custom-form-main]');
      var gate = root.querySelector('[data-custom-form-submitted]');
      var invalid = root.querySelector('[data-custom-form-invalid]');
      if (main) main.hidden = true;
      if (invalid) invalid.hidden = true;
      if (gate) gate.hidden = false;
    }

    function resolveOrderId(root) {
      return (
        cleanOrderId(root.getAttribute('data-prefill-order-id')) ||
        cleanOrderId(root.getAttribute('data-prefill-order-name')) ||
        cleanOrderId(urlOrderId())
      );
    }

    function enforceAlreadySubmitted(root) {
      if (!root) return false;
      if (root.getAttribute('data-order-access') === 'submitted') {
        showAlreadySubmitted(root);
        return true;
      }
      if (root.getAttribute('data-order-access') === 'mismatch') return false;

      var orderId = resolveOrderId(root);
      if (!orderId) return false;

      var successEl =
        root.querySelector('[data-contact-form-success]') ||
        root.querySelector('.contact-form__success');
      var justSubmitted = root.getAttribute('data-form-just-submitted') === 'true';

      if ((successEl && !successEl.hidden) || justSubmitted) {
        markLocalSubmission(root, orderId);
        showAlreadySubmitted(root);
        return true;
      }

      if (hasLocalSubmission(root, orderId)) {
        showAlreadySubmitted(root);
        return true;
      }

      return false;
    }

    function isDesignMode(root) {
      if (root && root.getAttribute('data-design-mode') === 'true') return true;
      try {
        return !!(window.Shopify && Shopify.designMode);
      } catch (e) {
        return false;
      }
    }

    function redirectToLogin(root) {
      if (!root) return false;
      if (isDesignMode(root)) return false;
      if (root.getAttribute('data-customer-logged-in') === 'true') return false;
      if (root.getAttribute('data-require-login') !== 'true') return false;

      var loginUrl = root.getAttribute('data-login-url');
      if (!loginUrl) {
        var accountLogin = root.getAttribute('data-account-login') || '/account/login';
        var returnTo = window.location.pathname + window.location.search;
        loginUrl = accountLogin + '?return_to=' + encodeURIComponent(returnTo);
      }
      window.location.replace(loginUrl);
      return true;
    }

    function fillForm(root) {
      if (!root || root.getAttribute('data-prefill-bound') === '1') return;
      if (root.getAttribute('data-order-access') === 'mismatch') return;
      if (root.getAttribute('data-order-access') === 'submitted') return;
      root.setAttribute('data-prefill-bound', '1');

      var first = root.getAttribute('data-prefill-first-name') || '';
      var last = root.getAttribute('data-prefill-last-name') || '';
      var email = root.getAttribute('data-prefill-email') || '';
      var orderName = root.getAttribute('data-prefill-order-name') || '';
      var orderId = root.getAttribute('data-prefill-order-id') || urlOrderId();

      var firstInput = root.querySelector('input[name="contact[first_name]"]');
      var lastInput = root.querySelector('input[name="contact[last_name]"]');
      var emailInput =
        root.querySelector('input[name="contact[email]"]') ||
        root.querySelector('input[type="email"][name^="contact["]');

      if (firstInput && first && !firstInput.value) firstInput.value = first;
      if (lastInput && last && !lastInput.value) lastInput.value = last;
      if (emailInput && email && !emailInput.value) emailInput.value = email;

      var form = root.querySelector('form');
      if (!form) return;

      function ensureHidden(name, value) {
        if (!value) return;
        var existing = form.querySelector('input[name="' + name + '"]');
        if (existing) {
          existing.value = value;
          return;
        }
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      }

      // Redirect to homepage after Shopify contact form submit.
      try {
        var homeUrl = root.getAttribute('data-home-url') || '/';
        if (!homeUrl || homeUrl === '') homeUrl = '/';
        ensureHidden('return_to', homeUrl);
      } catch (e) {}

      ensureHidden('contact[order_number]', orderId || orderName);
      ensureHidden('contact[order_name]', orderName);
      if (orderName || orderId) {
        ensureHidden(
          'contact[subject]',
          'Award Travel Concierge Booking — Order ' + (orderName || orderId)
        );
      }

      var payloadEl = root.querySelector('[data-custom-form-order-payload]');
      if (payloadEl) {
        try {
          var payload = JSON.parse(payloadEl.textContent || '{}');
          if (payload.subject) ensureHidden('contact[subject]', payload.subject);
          if (payload.fields) {
            Object.keys(payload.fields).forEach(function (key) {
              var value = payload.fields[key];
              if (value === null || value === undefined || value === '') return;
              ensureHidden('contact[' + key + ']', String(value));
            });
          }
        } catch (e) {
          /* ignore malformed payload */
        }
      }

      form.addEventListener('submit', function () {
        var id = resolveOrderId(root) || orderId || orderName;
        try {
          if (id && window.sessionStorage) {
            sessionStorage.setItem('tpa_custom_form_active_order', cleanOrderId(id));
          }
        } catch (e) {}
        markLocalSubmission(root, id);
      });
    }

    function init() {
      document.querySelectorAll('[data-custom-form]').forEach(function (root) {
        var access = root.getAttribute('data-order-access');
        if (isDesignMode(root)) {
          fillForm(root);
          return;
        }
        if (access === 'login' || redirectToLogin(root)) {
          redirectToLogin(root);
          return;
        }
        if (access === 'mismatch' || enforceOrderOwnership(root)) return;
        if (access === 'submitted' || enforceAlreadySubmitted(root)) return;
        fillForm(root);
      });
    }

    document.addEventListener('custom-form:submitted', function (event) {
      var root = event.target && event.target.closest
        ? event.target.closest('[data-custom-form]')
        : document.querySelector('[data-custom-form]');
      if (!root) root = document.querySelector('[data-custom-form]');
      if (!root) return;
      var orderId = (event.detail && event.detail.orderId) || resolveOrderId(root);
      markLocalSubmission(root, orderId);
      var homeUrl = root.getAttribute('data-home-url') || '/';
      window.location.replace(homeUrl);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intake-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-intake-form]');
    if (!root) return;

    var params = new URLSearchParams(window.location.search);
    var orderNumber = params.get('order');
    if (!orderNumber) return;

    root.querySelectorAll('[data-intake-order]').forEach(function (input) {
      input.value = orderNumber;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var OPEN_CLASS = 'is-open';
    var BODY_LOCK = 'pa-modal-open';

    function cookieKey(id) {
      return 'pa-modal-' + id;
    }

    function getCookie(name) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }

    function setCookie(name, value, days) {
      var expires = '';
      if (days && days > 0) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
    }

    function isDesignMode() {
      return !!(window.Shopify && Shopify.designMode);
    }

    function wasShown(root) {
      if (isDesignMode()) return false;
      var id = root.getAttribute('data-modal-id') || 'promo';
      var frequency = root.getAttribute('data-frequency') || 'session';
      if (frequency === 'always') return false;
      if (frequency === 'session') {
        try {
          return sessionStorage.getItem(cookieKey(id)) === '1';
        } catch (e) {
          return false;
        }
      }
      return getCookie(cookieKey(id)) === '1';
    }

    function markShown(root) {
      if (isDesignMode()) return;
      var id = root.getAttribute('data-modal-id') || 'promo';
      var frequency = root.getAttribute('data-frequency') || 'session';
      if (frequency === 'always') return;
      if (frequency === 'session') {
        try {
          sessionStorage.setItem(cookieKey(id), '1');
        } catch (e) {}
        return;
      }
      var days = parseInt(root.getAttribute('data-cookie-days') || '7', 10);
      setCookie(cookieKey(id), '1', days);
    }

    function openModal(root, options) {
      if (!root) return;
      var opts = options || {};
      if (!root.hidden && root.classList.contains(OPEN_CLASS)) return;
      root.hidden = false;
      root.classList.add(OPEN_CLASS);
      document.body.classList.add(BODY_LOCK);
      document.body.style.overflow = 'hidden';
      if (!opts.skipFocus) {
        var closeBtn = root.querySelector('[data-pa-modal-close]');
        if (closeBtn) closeBtn.focus();
      }
      if (!opts.preview) markShown(root);
      root.dispatchEvent(
        new CustomEvent('pa-modal:opened', {
          bubbles: true,
          detail: { modalId: root.getAttribute('data-modal-id') || '' }
        })
      );
    }

    function closeModal(root) {
      if (!root) return;
      root.classList.remove(OPEN_CLASS);
      root.hidden = true;
      if (!document.querySelector('[data-pa-modal].' + OPEN_CLASS)) {
        document.body.classList.remove(BODY_LOCK);
        document.body.style.overflow = '';
      }
    }

    function findById(modalId) {
      return document.querySelector('[data-pa-modal][data-modal-id="' + modalId + '"]');
    }

    function findBySectionId(sectionId) {
      if (!sectionId) return null;
      return (
        document.getElementById('PaModal-' + sectionId) ||
        document.querySelector('#shopify-section-' + sectionId + ' [data-pa-modal]')
      );
    }

    function canPreview(root) {
      return !!(root && isDesignMode() && root.getAttribute('data-editor-preview') !== 'false');
    }

    function canAutoOpen(root) {
      if (!root) return false;
      if (isDesignMode()) return false;
      if (root.getAttribute('data-enabled') !== 'true') return false;
      if (root.getAttribute('data-homepage-only') === 'true' && root.getAttribute('data-is-home') !== 'true') {
        return false;
      }
      if (wasShown(root)) return false;
      return true;
    }

    function bindRoot(root) {
      if (!root || root.dataset.paModalBound === '1') return;
      root.dataset.paModalBound = '1';

      root.addEventListener('click', function (event) {
        var closeEl = event.target.closest('[data-pa-modal-close]');
        var overlay = event.target.closest('[data-pa-modal-overlay]');
        if (closeEl && root.contains(closeEl)) {
          closeModal(root);
          return;
        }
        if (overlay && root.contains(overlay) && root.getAttribute('data-close-overlay') === 'true') {
          if (canPreview(root)) return;
          closeModal(root);
        }
      });

      var trigger = root.getAttribute('data-trigger') || 'manual';
      if (!canAutoOpen(root) || trigger === 'manual') return;

      if (trigger === 'delay') {
        var delay = parseInt(root.getAttribute('data-delay') || '2000', 10);
        window.setTimeout(function () {
          if (canAutoOpen(root)) openModal(root);
        }, Math.max(0, delay));
        return;
      }

      if (trigger === 'scroll') {
        var percent = parseInt(root.getAttribute('data-scroll-percent') || '50', 10);
        var fired = false;
        var onScroll = function () {
          if (fired) return;
          var doc = document.documentElement;
          var scrollTop = window.scrollY || doc.scrollTop;
          var height = doc.scrollHeight - doc.clientHeight;
          var scrolled = height > 0 ? (scrollTop / height) * 100 : 100;
          if (scrolled >= percent) {
            fired = true;
            window.removeEventListener('scroll', onScroll);
            if (canAutoOpen(root)) openModal(root);
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return;
      }

      if (trigger === 'exit_intent') {
        var exitFired = false;
        var onLeave = function (event) {
          if (exitFired) return;
          if (event.clientY > 0) return;
          exitFired = true;
          document.removeEventListener('mouseout', onLeave);
          if (canAutoOpen(root)) openModal(root);
        };
        document.addEventListener('mouseout', onLeave);
      }
    }

    function bindEditorPreview() {
      if (!isDesignMode() || document.body.dataset.paModalEditorBound === '1') return;
      document.body.dataset.paModalEditorBound = '1';

      document.addEventListener('shopify:section:select', function (event) {
        var root = findBySectionId(event.detail && event.detail.sectionId);
        if (!root && event.target) root = event.target.querySelector('[data-pa-modal]');
        if (canPreview(root)) openModal(root, { preview: true, skipFocus: true });
      });

      document.addEventListener('shopify:section:deselect', function (event) {
        var root = findBySectionId(event.detail && event.detail.sectionId);
        if (!root && event.target) root = event.target.querySelector('[data-pa-modal]');
        if (root) closeModal(root);
      });

      document.addEventListener('shopify:block:select', function (event) {
        var root = findBySectionId(event.detail && event.detail.sectionId);
        if (canPreview(root)) openModal(root, { preview: true, skipFocus: true });
      });

      document.addEventListener('shopify:section:load', function (event) {
        var root = findBySectionId(event.detail && event.detail.sectionId);
        if (!root && event.target) root = event.target.querySelector('[data-pa-modal]');
        if (root) {
          root.dataset.paModalBound = '';
          bindRoot(root);
        }
      });
    }

    function init() {
      document.querySelectorAll('[data-pa-modal]').forEach(bindRoot);
      bindEditorPreview();

      if (!document.body.dataset.paModalDelegation) {
        document.body.dataset.paModalDelegation = '1';

        document.addEventListener('click', function (event) {
          var opener = event.target.closest('[data-modal-open]');
          if (!opener) return;
          var id = (opener.getAttribute('data-modal-open') || '').trim();
          if (!id) return;
          var root = findById(id);
          if (!root) return;
          event.preventDefault();
          event.stopPropagation();
          openModal(root);
        });

        document.addEventListener('keydown', function (event) {
          if (event.key !== 'Escape') return;
          document.querySelectorAll('[data-pa-modal].' + OPEN_CLASS).forEach(function (root) {
            if (canPreview(root)) return;
            if (root.getAttribute('data-close-escape') === 'true') closeModal(root);
          });
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
